import LocationMutations from './mutations'
import LocationActions from './actions'
import LocationGetters from './getters'
import LocationState from './state'
export default {
  namespaced: true,
  state: LocationState,
  mutations: LocationMutations,
  actions: LocationActions,
  getters: LocationGetters
}
